import { Text, UseModalState } from "@clipboard-health/ui-components";
import { Button } from "@mui/material";
import { CLIPBOARD_SCORE } from "@src/appV2/ClipboardScore/constants";
import { CommonDialog } from "@src/appV2/lib";
import { REMOVE_LICENSE_MODAL } from "@src/constants/modalAlerts";

export interface RemoveLicenseDialogProps {
  modalState: UseModalState;
  onSubmit: () => void;
}

export function RemoveLicenseDialog(props: RemoveLicenseDialogProps) {
  const { modalState, onSubmit } = props;
  return (
    <CommonDialog
      modalState={modalState}
      title={REMOVE_LICENSE_MODAL.TITLE}
      actions={
        <>
          <Button
            variant="contained"
            color="error"
            fullWidth
            aria-label="Confirm Remove License"
            onClick={() => onSubmit()}
          >
            Remove
          </Button>
          <Button variant="outlined" fullWidth onClick={() => modalState.closeModal()}>
            Cancel
          </Button>
        </>
      }
    >
      <Text textAlign="center" paragraph>
        {REMOVE_LICENSE_MODAL.CONTENT}
      </Text>
      <Text textAlign="center" bold>
        All booked shifts in this state will be cancelled, which may result in {CLIPBOARD_SCORE}{" "}
        point deductions.
      </Text>
    </CommonDialog>
  );
}
